<template>
    <div class="filter">
        <van-dropdown-menu>
            <van-dropdown-item :title="cityName || '城市'" ref="cityItem">
                <van-tree-select
                        :items="cityList"
                        :active-id.sync="areaIds"
                        :main-active-index.sync="cityParentIndex"
                        @click-item="selectCity"
                />
                <div class="operation">
                    <div class="reset" @click="resetCity">重置</div>
                    <div class="confirm" @click="confirmCity">确定</div>
                </div>
            </van-dropdown-item>
        </van-dropdown-menu>
        <van-dropdown-menu v-if="type == 'positions'">
            <van-dropdown-item :title="industryName || '行业'" ref="industryItem">
                <van-tree-select
                        :max="max"
                        :items="industryList"
                        :active-id.sync="industryIds"
                        :main-active-index.sync="industryParentIndex"
                        @click-item="selectIndustry"
                />
                <div class="operation">
                    <div class="reset" @click="resetIndustry">重置</div>
                    <div class="confirm" @click="confirmIndustry">确定</div>
                </div>
            </van-dropdown-item>
        </van-dropdown-menu>
        <van-dropdown-menu>
            <van-dropdown-item :title="salaryName || '年薪'" v-model="salary" :options="salaryList" ref="salaryItem"
                               @change="changeSalary"/>
        </van-dropdown-menu>
        <van-dropdown-menu v-if="type == 'positions'">
            <van-dropdown-item title="综合" ref="otherItem">
                <div class="other-dropdown" style="overflow-y: auto;max-height: 300px;">
                    <van-collapse v-model="activeNames">
                        <!-- <van-collapse-item title="标签筛选" name="tag">
                            <span class="tag small"
                                  :class="curTags.includes(item.positionTagIdsForSearchUnderRange) ? 'cur' : ''"
                                  v-for="item in tagList"
                                  @click="addPositionTag(item.positionTagIdsForSearchUnderRange)">{{item.name}}</span>
                        </van-collapse-item> -->
                        <van-collapse-item title="综合排序" name="order">
                            <span class="tag medium" :class="sortType == item.sortType ? 'cur' : ''"
                                  v-for="item in orderList" @click="selectOrder(item.sortType)">{{item.name}}</span>
                        </van-collapse-item>
                    </van-collapse>
                    <van-cell title="公司筛选">
                        <template slot="default">
                            <div class="self-switch" :class="switchOn ? '' : 'self-switch-on'" @click="changeSwitch">
                                <span>只看</span>
                                <span>不看</span>
                                <div class="self-switch-ball">{{switchOn ? "只看" : "不看"}}</div>
                            </div>
                        </template>
                    </van-cell>
                    <div class="company-filter-con">
                        <span v-if="!loading" class="tag medium"
                              :class="{'cur': curCompanys.includes(item.code), 'disabled': !curCompanys.includes(item.code) && curCompanys.length > 4}"
                              v-for="item in companyList" @click="addCompanyTags(item.code)">{{item.name}}</span>
                        <van-loading style="padding: 10px 0 20px 0;text-align: center;" type="spinner" v-if="loading"/>
                    </div>
                </div>
                <div class="operation">
                    <div class="reset" @click="resetOther">重置</div>
                    <div class="confirm" @click="confirmOther">确定</div>
                </div>
            </van-dropdown-item>
        </van-dropdown-menu>
        <van-dropdown-menu v-if="type != 'positions'">
            <van-dropdown-item :title="degreeName || '学历'" v-model="degree" :options="degreeList" ref="degreeItem"
                               @change="changeDegree"/>
        </van-dropdown-menu>
        <van-dropdown-menu v-if="type != 'positions'">
            <van-dropdown-item :title="workName || '年限'" v-model="work" :options="workList" ref="workItem"
                               @change="changeWork"/>
        </van-dropdown-menu>
    </div>
</template>

<script>
  import { mapState } from "vuex";
  import Vue from "vue";
  export default {
    name: "filterNav",
    props: {
      type: {},
      tagList: {
        default() {
          return [];
        }
      },
      companyList: {
        default() {
          return [];
        }
      },
      loading: {}
    },
    data() {
      return {
        max: 3,
        parents: [],
        degreeName: "",
        degree: 0,
        work: 0,
        degreeList: [
          { text: "全部", value: 0 },
          { text: "大专", value: 8 },
          { text: "本科", value: 1 },
          { text: "硕士", value: 3 },
          { text: "博士", value: 4 },
          { text: "博士后", value: 5 },
          { text: "MBA", value: 6 }
        ],
        workList: [
          { text: "全部", value: 0 },
          { text: "1-3年", value: 1, minWorkYear: 1, maxWorkYear: 3 },
          { text: "3-5年", value: 2, minWorkYear: 3, maxWorkYear: 5 },
          { text: "5-8年", value: 3, minWorkYear: 5, maxWorkYear: 8 },
          { text: "8年以上", value: 4, minWorkYear: 8 }
        ],
        workName: "",
        switchOn: this.$route.query.switchOn==='false'||this.$route.query.switchOn===false ? false : true,
        iscompany: true,
        curCompanys: this.$route.query.companyId ? this.$route.query.companyId.split("|").map(item => String(item)) : [],
        curTags: this.$route.query.positionTagIdsForSearchUnderRange ? this.$route.query.positionTagIdsForSearchUnderRange.split(",") : [],
        orderList: [
          { sortType: 0, name: "综合排序" },
          { sortType: 3, name: "最近更新" },
          { sortType: 2, name: "最新发布" },
          { sortType: 12, name: "反馈最快" },
          { sortType: 11, name: "薪资最高" },
          { sortType: 5, name: "佣金最多" },
          { sortType: 4, name: "保证期最短" }
        ],
        sortType: this.$route.query.sortType,
        activeNames: ["order"],
        cityName: "",
        cityList: [],
        areaIds: 0,
        cityParentIndex: 0,
        industryName: "",
        industryList: [],
        industryIds: [],
        industryParentIndex: 0,
        salary: 0,
        salaryName: "",
        salaryList: [
          { text: "全部", value: 0 },
          { text: "10万以下", value: 7, maxSalary: 100000 },
          { text: "10-20万", value: 1, minSalary: 100000, maxSalary: 200000 },
          { text: "20-30万", value: 2, minSalary: 200000, maxSalary: 300000 },
          { text: "30-50万", value: 3, minSalary: 300000, maxSalary: 500000 },
          { text: "50-100万", value: 4, minSalary: 500000, maxSalary: 1000000 },
          // { text: "80-100万", value: 5, minSalary: 800000, maxSalary: 1000000 },
          { text: "100万以上", value: 6, minSalary: 1000000 }
        ]
      };
    },
    computed: {
      ...mapState({
        cities: state => state.comp.cities || {}
      })
    },
    methods: {
      resetOther() {
        this.curTags = [];
        this.sortType = "";
        this.curCompanys = [];
        this.switchOn = true;
      },
      confirmOther() {
        let params = { ...this.$route.query };

        params.companyId = this.curCompanys.join("|");
        params.switchOn = this.switchOn;
        if (!this.curCompanys.length) {
          delete params.companyId;
          delete params.switchOn;
        }

        params.positionTagIdsForSearchUnderRange = this.curTags.join(",");
        if (!this.curTags.length)
          delete params.positionTagIdsForSearchUnderRange;

        params.sortType = this.sortType;
        if (!this.sortType)
          delete params.sortType;

        this.$refs.otherItem.toggle(false);
        this.$router.replace({ name: this.$route.name, query: { ...params } });
      },
      changeDegree(value) {
        let params = { ...this.$route.query };
        delete params.companyId;
        this.$refs.degreeItem.toggle(false);
        this.degreeList.forEach(item => {
          if (item.value == value) {
            this.degreeName = item.text == "全部" ? "" : item.text;
          }
        });
        params.degreeIds = value;
        if (!value)
          delete params.degreeIds;

        this.$router.replace({ name: this.$route.name, query: { ...params } });
      },
      changeWork(value) {
        let params = { ...this.$route.query };
        delete params.companyId;
        let temp = {};
        this.workList.forEach(item => {
          if (value == item.value) {
            this.workName = item.text == "全部" ? "" : item.text;
            temp = item;
          }
        });
        this.$refs.degreeItem.toggle(false);
        params.minWorkYear = temp.minWorkYear;
        params.maxWorkYear = temp.maxWorkYear;
        if (!temp.minWorkYear)
          delete params.minWorkYear;

        if (!temp.maxWorkYear)
          delete params.maxWorkYear;

        this.$router.replace({ name: this.$route.name, query: { ...params } });
      },
      confirmCity() {
        let params = { ...this.$route.query };
        delete params.companyId;
        params.areaIds = this.areaIds;
        if (!this.areaIds)
          delete params.areaIds;

        this.$refs.cityItem.toggle(false);
        this.$router.replace({ name: this.$route.name, query: { ...params } });
      },
      resetCity() {
        this.cityName = "";
        this.areaIds = 0;
        this.cityList.forEach(item => {
          item.info = null;
        });
      },
      confirmIndustry() {
        let params = { ...this.$route.query };
        delete params.companyId;
        if (this.industryIds && this.industryIds.length) {
          params.industryIds = this.industryIds.join("|");
        } else {
          delete params.industryIds;
        }

        this.$refs.industryItem.toggle(false);
        this.$router.replace({ name: this.$route.name, query: { ...params } });
      },
      resetIndustry() {
        this.industryName = "";
        this.industryIds = [];
        this.industryList.forEach(item => {
          item.info = null;
        });
      },
      changeSwitch() {
        this.switchOn = !this.switchOn;
      },
      addCompanyTags(code) {
        if (this.curCompanys.length > 4 && !this.curCompanys.includes(code))
          return;

        if (this.curCompanys.includes(code)) {
          this.curCompanys = this.curCompanys.filter(item => item != code);
        } else {
          this.curCompanys.push(code);
        }
      },
      addPositionTag(positionTagIdsForSearchUnderRange) {
        if (this.curTags.includes(positionTagIdsForSearchUnderRange)) {
          this.curTags = this.curTags.filter(item => item != positionTagIdsForSearchUnderRange);
        } else {
          this.curTags.push(positionTagIdsForSearchUnderRange);
        }

        let params = { ...this.$route.query };
        delete params.companyId;
        params.positionTagIdsForSearchUnderRange = this.curTags.join(",");
        if (!this.curTags.length)
          delete params.positionTagIdsForSearchUnderRange;

        this.$router.replace({ name: this.$route.name, query: { ...params } });
      },
      selectOrder(sortType) {
        this.sortType = sortType == this.sortType ? 0 : sortType;
        let params = { ...this.$route.query };
        params.sortType = this.sortType;
        if (!this.sortType)
          delete params.sortType;

        this.$router.replace({ name: this.$route.name, query: { ...params } });
      },
      changeSalary(value) {

        let temp = {};
        this.salaryList.forEach(item => {
          if (item.value == value) {
            this.salaryName = item.text == "全部" ? "" : item.text;
            temp = item;
          }
        });
        let params = { ...this.$route.query };
        delete params.companyId;
        params.minSalary = temp.minSalary;
        params.maxSalary = temp.maxSalary;
        if (!temp.minSalary) {
          delete params.minSalary;
        }
        if (!temp.maxSalary) {
          delete params.maxSalary;
        }

        this.$refs.salaryItem.toggle(false);
        this.$router.replace({ name: this.$route.name, query: { ...params } });
      },
      selectCity(data) {

        this.cityName = data.text == '不限' ? data.displayName : data.text;
        this.cityList.forEach((item, index) => {
          let info = 0;
          item.children.forEach(ch => {
            if ((ch.id == data.id) && (index == this.cityParentIndex)) {
              info++;
            }
          });
          item.info = info ? info : null;
        });
      },
      selectIndustry(data) {
        // setTimeout(() => {
        //   this.industryList.forEach((item, index) => {
        //     let info = 0;
        //     item.children.forEach(ch => {
        //       if (this.industryIds.includes(ch.id)) {
        //         info++;
        //       }
        //     });
        //     item.info = info ? info : null;
        //   });
        // });
        this.$nextTick(()=>{
          this.industryList.forEach((item, index) => {
            let info = 0;
            item.children.forEach(ch => {
              if (this.industryIds.includes(ch.id)) {
                info++;
              }
            });
            item.info = info ? info : null;
          });
          this.industryName = this.industryIds && this.industryIds.length ? Vue.filter('industry')(this.industryIds) : '';
        })
      },
      init() {
        if (this.$route.query.minSalary || this.$route.query.maxSalary) {
          let min = this.$route.query.minSalary ? ~~this.$route.query.minSalary : undefined;
          let max = this.$route.query.maxSalary ? ~~this.$route.query.maxSalary : undefined;
          this.salaryList.forEach(item => {
            if (item.minSalary == min && item.maxSalary == max) {
              this.salary = item.value;
              this.salaryName = item.text;
            }
          });
        }
      },
      setCityAndIndustry(data){
        let province = JSON.parse(JSON.stringify(data.province)),
          hotCitys = JSON.parse(JSON.stringify(data.positionHotcitys)),
          citys = data.citys;

        let areaIds = this.$route.query.areaIds ? ~~this.$route.query.areaIds : 0;
        let industryIds = this.$route.query.industryIds ? this.$route.query.industryIds.split("|").map(item => Number(item)) : [];

        province.forEach(pv => {
          pv.text = pv.name;
          pv.info = null;
          pv.citys = pv.citys || [];
          if(pv.citys.length > 1){
            pv.citys.unshift(pv.id);
          }
          let children = [];
          pv.citys.forEach(ct => {
            let item = (ct+'').length == 3 ? {id: ct, name: '不限', displayName: pv.name} : citys[ct];
            item.text = item.name;
            if (ct == this.$route.query.areaIds) {
              this.cityName = item.name == '不限' ? item.displayName : item.name;
              pv.info = 1;
            }
            children.push(item);
          });
          pv.children = children;
        });

        hotCitys.forEach(hc => {
          hc.id = hc.code;
          hc.text = hc.name;
        });

        province.unshift({
          id: 0,
          text: "热门城市",
          children: hotCitys
        });

        this.cityList = province;
        this.areaIds = areaIds;

        let baseIndustryIds = JSON.parse(JSON.stringify(data.baseIndustryIds)),
          industryMaps = JSON.parse(JSON.stringify(data.industry));


        baseIndustryIds.forEach(id => {
          let item = industryMaps[id];
          item.text = item.displayName;
          item.info = 0;
          item.nextLevelIds = item.nextLevelIds || [];
          item.nextLevelIds.unshift(id);
          let children = [];
          item.nextLevelIds.forEach(next => {
            let ch = (next+'').length==3 ? {id: next, name: '不限', displayName: '不限'} : industryMaps[next];
            ch.text = ch.displayName;
            if (industryIds.includes(next)) {
              item.info++;
            }
            children.push(ch);
          });
          item.info = item.info || null;
          item.children = children;
          this.industryList.push(item);
        });

        this.industryIds = industryIds;
        this.industryName = industryIds && industryIds.length ? Vue.filter('industry')(industryIds) : '';
      }
    },
    watch: {
      cities(n,o){
        if(n){
          this.setCityAndIndustry(n);
        }
      }
    },
    created() {
      this.init();
      if(window.METADATA){
        this.setCityAndIndustry(window.METADATA);
      }
    }
  };

</script>


<style scoped lang="scss">
    .filter {
        height: 45px;
        display: flex;

        .self-switch {
            position: relative;
            display: inline-block;
            box-sizing: content-box;
            width: 84px;
            height: 20px;
            background: #F5F5F5;
            border-radius: 10px;

            span {
                font-size: 12px;
                color: #666666;
                text-align: center;
                line-height: 20px;
                width: 50%;
                display: inline-block;
                height: 20px;
                line-height: 20px;
                float: left;
            }

            &.self-switch-on {
                .self-switch-ball {
                    -webkit-transform: translateX(42px);
                    transform: translateX(42px);
                }
            }

            .self-switch-ball {
                color: #fff;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
                width: 42px;
                height: 20px;
                text-align: center;
                line-height: 20px;
                font-size: 12px;
                background: #22BAA5;
                border-radius: 10px;
                box-shadow: 0 3px 1px 0 rgba(0, 0, 0, 0.05), 0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 3px 3px 0 rgba(0, 0, 0, 0.05);
                -webkit-transition: -webkit-transform 0.3s;
                transition: -webkit-transform 0.3s;
                transition: transform 0.3s;
                transition: transform 0.3s, -webkit-transform 0.3s;
            }
        }

        .tag {
            cursor: default;
            height: 35px;
            line-height: 35px;
            margin-bottom: 15px;
            margin-right: 15px;
            border-radius: 4px;
            font-size: 14px;
            color: #666666;
            text-align: center;
            border: 0.5px solid #E5E5E5;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding: 0 10px;

            &.small {
                width: 56px;
            }

            &.medium {
                width: 99px;
            }

            &.cur {
                border: 0.5px solid #22BAA5;
                background: #22BAA5;
                color: #fff;
            }

            &.disabled {
                border-color: #ccc;
                color: #ccc;
            }
        }

        .company-filter-con {
            padding: 16px;
        }
    }
</style>

<style lang="scss">
    .filter {
        .van-sidebar-item--select {
            border-color: #22BAA5;
        }

        .van-tree-select__item--active {
            color: #22BAA5;
        }

        .van-tree-select__selected {
            color: #22BAA5;
        }

        .van-dropdown-item__content {
            max-height: 100%;
        }

        .van-dropdown-menu {
            /*flex-grow: 1;*/
            width: 25%;
            .van-dropdown-menu__title{
                padding: 0 14px;
                &:after{
                  right: 2px;
                };
            }
        }

        .operation {
            display: flex;

            div {
                font-size: 14px;
                color: #333;
                flex-grow: 1;
                height: 45px;
                line-height: 45px;
                text-align: center;

                &.confirm {
                    background: #22BAA5;
                    color: #fff;
                }

                &.reset {
                    box-shadow: inset 0 1px 0 0 #ddd;
                }
            }
        }
    }
</style>
